import { combineReducers } from 'redux';
import AlertMessage from './alertMessage';
import DamProfile from './damProfile';
import DamStatus from './damStatus';
import Pressure from './pressure';
import Rain from './rain';
import Seismic from './seismic';
import Seepage from './seepage';
import SeepageV2 from './seepageV2';
import WaterStorage from './waterStorage';
import WebConfig from './webConfig';

export default combineReducers({
  AlertMessage,
  DamProfile,
  DamStatus,
  Pressure,
  Rain,
  Seepage,
  SeepageV2,
  Seismic,
  WaterStorage,
  WebConfig,
});



// WEBPACK FOOTER //
// ./resources/assets/js/reducers/index.js